@if (_warning(); as warning) {
  <div
    class="quota-warning m-flex m-gap:2 m-flex-items:start m-padding:2 m-border-radius:lg m-bg-color:warning-pale m-text-color:warning-dark m-text-body:small"
    role="status"
  >
    <i class="myre-icon-warning"></i>
    <div class="m-flex m-flex-column m-gap:1 m-flex-grow">
      <span>{{ warning.message }}</span>
      <div class="quota-warning__gauge">
        <span
          class="quota-warning__gauge-fill"
          [style.width.%]="_gaugePercent()"
        ></span>
      </div>
    </div>
  </div>
}
